import { ActionIcon, CopyButton, Menu } from "@mantine/core";
import {
  MoreVertRounded,
  RefreshRounded,
  ShareRounded,
} from "@mui/icons-material";
import { TestStates } from "@tsTypes/test-schema";
import { useRouter } from "next/navigation";
import { Dispatch, SetStateAction } from "react";
import { deleteActiveTestSession } from "../../../../../../../../features/activeTestSessions/activeTestSessionsSlice";
import { useCustomDispatch } from "../../../../../../../../lib/redux/hooks";

export default function TestActionsDropdown({
  testId,
  hasAttemptedQuestions,
  hasStartedClock,
  subjectNameLower,
  setTestStatus,
  testStatus,
  shareable,
}: {
  testId: string;
  hasAttemptedQuestions: boolean;
  hasStartedClock: boolean;
  subjectNameLower: string;
  setTestStatus: Dispatch<SetStateAction<TestStates>>;
  testStatus: TestStates;
  shareable?: true;
}) {
  const router = useRouter();
  const dispatch = useCustomDispatch();
  const canReset = hasAttemptedQuestions || hasStartedClock;
  const shareableLink = shareable
    ? `${process.env.NEXT_PUBLIC_FRONTEND_BASE_URL}/ib/${subjectNameLower}/test-taker?testId=${testId}`
    : undefined;

  const handleReset = () => {
    setTestStatus("paused");
    dispatch(deleteActiveTestSession({ testId }));
    router.push("#");
    router.refresh();
  };

  return (
    <Menu position="bottom-end" withArrow>
      <Menu.Target>
        <ActionIcon color="darkblue" variant="transparent" size="sm">
          <MoreVertRounded style={{ width: 22, height: 22 }} />
        </ActionIcon>
      </Menu.Target>

      <Menu.Dropdown>
        <Menu.Item
          leftSection={<RefreshRounded style={{ width: 18, height: 18 }} />}
          onClick={handleReset}
          disabled={!canReset}
          color={canReset ? "incorrect" : "gray"}
        >
          Restart Test
        </Menu.Item>

        {shareableLink && (
          <CopyButton value={shareableLink} timeout={2000}>
            {({ copied, copy }) => (
              <Menu.Item
                leftSection={<ShareRounded style={{ width: 18, height: 18 }} />}
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  copy();
                }}
                color={copied ? "green" : "blue"}
                closeMenuOnClick={false}
              >
                {copied ? "Link Copied!" : "Challenge Friend"}
              </Menu.Item>
            )}
          </CopyButton>
        )}
      </Menu.Dropdown>
    </Menu>
  );
}
